import React, { useState } from 'react';
import * as styles from '../styles/nav.module.scss';
import { Link } from 'gatsby';
import { useStaticQuery, graphql } from 'gatsby';

function Nav() {
  const [showNav, setShowNav] = useState(false);
  const [activeBtnClass, setActiveBtnClass] = useState('');

  function toggleNavigation() {
    setShowNav(!showNav);

    if (activeBtnClass.length === 0) {
      setActiveBtnClass('is-active');
      setBodyScroll('hidden');
    } else {
      setActiveBtnClass('');
      setBodyScroll('visible');
    }
  }

  function setBodyScroll(visibility) {
    document.body.style.overflow = visibility;
  }

  return (
    <>
      <button
        className={`hamburger hamburger--squeeze js-hamburger ${activeBtnClass}`}
        type='button'
        aria-label='Menu'
        aria-controls='navigation'
        onClick={() => toggleNavigation()}
      >
        <span className='hamburger-box'>
          <span className='hamburger-inner'></span>
        </span>
      </button>
      {showNav ? <NavOverlay setBodyScroll={setBodyScroll} /> : ''}
    </>
  );
}

function NavOverlay({ setBodyScroll }) {
  const result = useStaticQuery(
    graphql`
      {
        cms {
          pages(
            where: {
              _or: [
                { type: "how_it_works" }
                { type: "contact" }
                { type: "connect_company" }
              ]
            }
          ) {
            type
            title
            slug
            sites {
              url
            }
          }
        }
      }
    `,
  );

  const pages = result.cms.pages.filter((page) =>
    page.sites.some((site) => site.url === process.env.GATSBY_FRONTEND_DOMAIN),
  );

  const order = ['how_it_works', 'contact', 'connect_company'];
  pages.sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type));

  return (
    <div className={styles.overlay}>
      <nav id='navigation'>
        <ul>
          {pages.map((page) => (
            <li key={page.slug}>
              <Link
                to={`/${page.slug}`}
                onClick={() => setBodyScroll('visible')}
              >
                {page.title}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
export default Nav;
